import { FullWidthSpace } from "melco-ui";
import { DisplayFieldErrors } from "melco-shared-logic";
import { HoopCategoryList } from "../HoopCategoryList";
export type HoopCategoriesTabProps = {

}


export const HoopCategoriesTab: React.FC<HoopCategoriesTabProps> = () => {




    return (<>
        <DisplayFieldErrors name="category_list" />
        <FullWidthSpace direction="vertical" size="small">
            <HoopCategoryList />
        </FullWidthSpace>
    </>)
}